// extracted by mini-css-extract-plugin
export var aboveInput = "_if-0";
export var actionButton = "_if-5";
export var actionButtonContainer = "_if-1";
export var actionIcon = "_if-6";
export var aiInfoContainer = "_if-2";
export var attachmentWrapper = "_if-7";
export var bold = "_if-3";
export var checkIcon = "_if-8";
export var clickingRecipientBar = "_if-11";
export var commentThreadSwitch = "_if-a";
export var draftImage = "_if-b";
export var draftImageContainer = "_if-c";
export var draftImages = "_if-e";
export var editButton = "_if-g";
export var editor = "_if-f";
export var editorContainer = "_if-y";
export var editorErrorTooltipWrapper = "_if-9";
export var headerDivider = "_if-h";
export var icon = "_if-i";
export var info = "_if-j";
export var internal = "_if-n";
export var internalDivider = "_if-k";
export var internalMessage = "_if-l";
export var messageInputCard = "_if-m";
export var messageInputForm = "_if-o";
export var messageInputFormInternal = "_if-p";
export var options = "_if-q";
export var publicMessageCustomer = "_if-s";
export var publicMessageMerchant = "_if-r";
export var removeImageButton = "_if-d";
export var replyButtons = "_if-t";
export var showSignatureButton = "_if-u";
export var spinner = "_if-v";
export var verticalButtonDivider = "_if-4";
export var visibilitySelector = "_if-w";
export var warning = "_if-x";
export var wrappingText = "_if-z";
export var writingInternalNoteTopBorder = "_if-10";